import { NonIdealState } from "@blueprintjs/core";
import React, { useContext } from "react";
import { useProjectActions } from "hooks/useProjectActions";
import { SelectedProjectContext } from "utils/context";

import "./ActionCards.scss";
import CustomLoader from "components/CustomLoader";
import ActionCard from "./ActionCard";

type Props = { search: string | undefined };

export default function ActionCards({ search }: Props) {
    const [selectedProject] = useContext(SelectedProjectContext);
    const [actions, loading, error] = useProjectActions(selectedProject?.projectId);

    return (
        <>
            {loading && (
                <div>
                    <CustomLoader />
                </div>
            )}
            {!loading && actions.length === 0 && (
                <NonIdealState
                    icon="add"
                    title="There Are No Actions For This Project"
                    description={"You can create an action by clicking on the New Button."}
                />
            )}
            {error && (
                <div>
                    <NonIdealState
                        icon="error"
                        title="Error Loading Actions"
                        description={"Please Contact the Administrator."}
                    />
                </div>
            )}
            <div className="cards">
                {actions
                    .filter(
                        (a) =>
                            !search ||
                            a.name.toLowerCase().includes(search.toLowerCase()) ||
                            a.type?.toLowerCase().includes(search.toLowerCase())
                    )
                    .map((a) => (
                        <ActionCard action={a} />
                    ))}
            </div>
        </>
    );
}
